import ApiService from '../apiservice';

class DegreeService extends ApiService {

    constructor() {
        super('/degree');
    }

    getAll() {
        return this.get(`${this.apiurl}/all`);
    }

    getDegreeById(id) {
        return this.get(`${this.apiurl}/${id}`);
    }

    getByDescription(description) {
        return this.get(`${this.apiurl}/description/${description}`);
    }
}

export default DegreeService;